import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetBuildingMapWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeEnum} from "../../utils/humanizers";
import { WorkOrder, WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface DashboardOpenWorkOrdersModalProps {
  workOrders: WorkOrder[];
  isOpen:boolean
  onClose: () => void;
}

export default function DashboardOpenWorkOrdersModal({
  workOrders,
  isOpen,
  onClose
}: DashboardOpenWorkOrdersModalProps) {
  

 const navigation = useNavigation<any>();
  useEffect(() => {

    
  }, [isOpen, workOrders]);

  const navigateToEdit = (id: string) => {
    window.open(`/web/workOrders/recordView?id=${id}`, "_blank");
  };

  return (
    <>
      <Modal
        centered
        width={1000}
        title="Work Orders"
        open={isOpen}
        onCancel={onClose}
        onOk={null}
        footer={null}
      >
        <Skeleton loading={false} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Work Order Reference</div>
            <div style={{ flex: 2 }}>Description</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            <div style={{ flex: 2 }}></div>
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={workOrders || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 }}>{item.reference}</div>
                <div style={{ flex: 2 }}>{item.description}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
                <div style={{ flex: 2, textAlign: "left" }}>
                  <Popconfirm
                    title="Are you sure you want to view this work order?"
                    onConfirm={() => navigateToEdit(item.id)}
                    >
                      <Button
                        type="link"
                      >
                        View Work Order
                      </Button>

                  </Popconfirm>
                  
                </div>
                
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
